/**************************************************
 * Nombre:       Tarjeta_Condiciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import icono from '../../Recursos/Temporales/tmp_icono.png'
import {theme} from "../../Tema";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Tarjeta_Condiciones = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 2, sm: 12, md: 2}} sx={{justifyContent: 'flex-start'}}>
                <img src={icono} width={60} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 10, sm: 12, md: 10}}
            sx={{pl: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: sCell ? 14 : 16, fontWeight: 700, color: theme.palette.primary.main, lineHeight: 1.2}}>ENVIO
                        GRATIS</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0.5}}>
                    <Typography sx={{fontSize: 14, color: '#00000080', lineHeight: 1.2}}>
                        es simplemente el texto de relleno de las imprentas y archivos de texto
                    </Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Condiciones    